import React, { useState } from 'react'
import { 
    Button, Grid, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Progress, useToast
} from '@chakra-ui/react'
import { useAccessAPI } from '../../hooks/useAccessAPI'
import StudentsService from '../../API/StudentsService'
import { toastError, toastSuccess } from '../../utils/globalHelper'
import { useAnalyticsStore } from '../../store/analyticsStore'
import { useProlongationFilesModalStore } from '../../store/modalsStore'

function ProlongationFileModal({isOpen, onClose}) {
    const toast = useToast()
    const [prolongationFiles, setProlongationFiles] = useAnalyticsStore(
        state => [state.prolongationFiles, state.setProlongationFiles]
    )
    const [isEditModal, state, setState] = useProlongationFilesModalStore(state => [state.isEdit, state.state, state.setState])
    const [isUploading, setIsUploading] = useState(false)

    const addProlongationFileAPI = useAccessAPI(StudentsService.addProlongationFile)
    const editProlongationFileAPI = useAccessAPI(StudentsService.editProlongationFile)

    const onBtn = async () => {
        setIsUploading(true)

        const formData = new FormData()
        formData.append("title", state.title)
        formData.append("prolongation_date", state.date + '-01')
        formData.append("file", state.file)
        if (isEditModal)
            formData.append("file_id", state.file_id)

        const response = isEditModal ? await editProlongationFileAPI(formData) 
                                     : await addProlongationFileAPI(formData)

        if (response?.status === 200 ?? response?.data) {
            if (!isEditModal) {
                console.log(prolongationFiles)
                console.log([...prolongationFiles, response.data])
                setProlongationFiles([...prolongationFiles, response.data])
                toast(toastSuccess("Файл загружен"))
            }
            else {
                console.log(prolongationFiles)
                console.log(prolongationFiles.map(
                    f => f.id === state.file_id ? response.data : f
                ))
                setProlongationFiles(prolongationFiles.map(
                    f => f.id === state.file_id ? response.data : f
                ))
                toast(toastSuccess("Выгрузка изменена"))
            }
            onClose()
        }
        else {
            toast(toastError("Не удалось загрузить файл"))
        }

        setIsUploading(false)
    }

    const btnIsDisabled = () => {
        if (isEditModal)
            return isUploading || (!state?.title && !state?.date && !state?.file)
        return !state?.title || !state?.date || !state?.file || isUploading
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    {isEditModal ? 'Редактирование выгрузки' : 'Добавление выгрузки'}
                </ModalHeader>
                <ModalCloseButton />

                <ModalBody>
                    <Grid gap='var(--default-gap)'>
                        <Input
                            type='month'
                            value={state?.date || ''}
                            onChange={(e) => setState({...state, date: e.target.value})}
                        />
                        <Input
                            value={state?.title || ''}
                            onChange={(e) => setState({...state, title: e.target.value})}
                        />
                        <Input
                            type='file'
                            onChange={(e) => setState({...state, file: e.target.files[0]})}
                            sx={{
                                "::file-selector-button": {
                                  height: 10,
                                  padding: 0,
                                  mr: 4,
                                  background: "none",
                                  border: "none",
                                  fontWeight: "bold",
                                }
                            }}
                        />
                        <Progress size='xs' colorScheme='orange' isIndeterminate={isUploading} />
                    </Grid>
                </ModalBody>

                <ModalFooter>
                    <Button
                        onClick={onBtn}
                        isDisabled={btnIsDisabled()}
                    >
                        {isEditModal ? 'Сохранить' : 'Добавить'}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default ProlongationFileModal
